import { useContext } from "react"
import { RoteirizacaoContext } from "./RoteirizacaoContext"

export function useRoteirizacaoContext() {
    const context = useContext(RoteirizacaoContext)
    if (context === undefined) {
        throw new Error(
            "useRoteirizacaoContext deve ser usado dentro de RoteirizacaoContextProvider"
        )
    }
    return context
}
